import React from 'react';

const STATUS_LABELS = {
  queued: 'En cola',
  processing: 'Preparando datos',
  completed: 'Completado',
  failed: 'Error',
};

const EntryGuideDocumentProgressModal = ({
  isOpen,
  guideCode,
  progress,
  onClose,
  allowClose = false,
}) => {
  if (!isOpen) return null;

  const pct = Math.min(100, Math.max(0, Number(progress?.progress_percent) || 0));
  const status = progress?.status || 'processing';
  const itemsProcessed = progress?.items_processed;
  const itemsTotal = progress?.items_total;
  const showItems = Number(itemsTotal) > 0 && progress?.phase === 'background';

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="entry-guide-doc-progress-title"
    >
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full border border-gray-200">
        <div className="px-5 py-4 border-b border-gray-200">
          <h3 id="entry-guide-doc-progress-title" className="text-lg font-semibold text-gray-900">
            Preparando guía{guideCode ? ` ${guideCode}` : ''}
          </h3>
          <p className="text-sm text-gray-500 mt-1">
            {progress?.message || 'Cargando datos para PDF o impresión…'}
          </p>
        </div>
        <div className="px-5 py-5 space-y-3">
          <div className="flex items-center justify-between text-xs text-gray-600">
            <span>{STATUS_LABELS[status] || 'Procesando'}</span>
            <span className="font-mono tabular-nums">{pct}%</span>
          </div>
          <div className="h-2.5 w-full rounded-full bg-gray-100 overflow-hidden">
            <div
              className="h-full bg-teal-600 transition-all duration-300 ease-out"
              style={{ width: `${pct}%` }}
            />
          </div>
          {showItems ? (
            <p className="text-xs text-gray-500">
              Ítems procesados:{' '}
              <span className="font-mono text-gray-700">
                {itemsProcessed ?? 0} / {itemsTotal}
              </span>
            </p>
          ) : null}
          {status === 'queued' ? (
            <p className="text-xs text-amber-700 bg-amber-50 border border-amber-100 rounded-md px-3 py-2">
              Guía con muchos ítems: la preparación corre en segundo plano para evitar cortes de red.
            </p>
          ) : null}
        </div>
        {allowClose ? (
          <div className="px-5 py-4 border-t border-gray-200 bg-gray-50 flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Cerrar
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default EntryGuideDocumentProgressModal;
